import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { Observable } from 'rxjs';
import { CompanySoftwareOptionsState, CompanySoftwareOptionsStore } from './cswo-store';
import { AppConfigService } from 'app/services/appConfig/appConfigService';
import { IKeyValuePair } from '@interfaces/IKeyValuePair';


@Injectable({ providedIn: 'root' })
export class CompanySoftwareOptionsQuery extends Query<CompanySoftwareOptionsState> {
	companySoftwareOptions$: Observable<IKeyValuePair> = this.select((state) => state.companySoftwareOptions);
	
	constructor(protected store: CompanySoftwareOptionsStore, private appConfigService: AppConfigService) {
		super(store);
	}

	get isCswoUpdated() {
		const lastUpdateTime = new Date(this.getValue().lastUpdate).getTime();
		const timeNow = new Date().getTime();
		const shouldFetch = !this.getValue().lastUpdate || timeNow - lastUpdateTime > this.appConfigService.appSettings.cachingTimeout;
		return Object.keys(this.getValue().companySoftwareOptions).length > 0 && !shouldFetch;
	}
}
